<template>
  <div class="">
    <b-navbar toggleable="md" type="dark" variant="info" class="pt-0 pb-0">
      <div class="container">
        <b-navbar-toggle target="nav_collapse_docentes"></b-navbar-toggle>
        <h1 class="text-center navbar-brand pt-0 pb-0 mb-0">Novedades</h1>
        <b-collapse is-nav id="nav_collapse_docentes">
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-item  href="#" @click="procesarCancelar">Volver</b-nav-item>
            <b-nav-item  href="#" v-if="docente && permiso('56FF5A35')" @click="creando=true">Crear Novedad</b-nav-item>
            <b-nav-item  href="#" @click="actualizar">Actualizar</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </div>
    </b-navbar>
    <div class="container pt-3 m-auto text-left ">
      <div v-if="docente">
        <h5 class="mb-3">Lista de Novedades para {{nombreCompleto}}</h5>
        <b-table-simple hover small caption-top responsive>
          <b-thead head-variant="light">
            <b-th style="width: 100px;">Fecha</b-th>
            <b-th>Hora</b-th>
            <b-th>Motivo</b-th>
            <b-th style="width: 180px;">Creado</b-th>
            <b-th style="width: 60px;"></b-th>
          </b-thead>
          <b-tbody v-if="novedades && novedades.length">
            <b-tr v-for="(novedad, index) in novedades" :key="index">
              <b-td >{{novedad.fecha}}</b-td>
              <b-td>{{novedad.hora}}</b-td>
              <b-td>{{novedad.observaciones}}</b-td>
              <b-td>{{novedad.created_at}}</b-td>
              <b-td>
                <b-btn size="sm" v-if="docente && permiso('56FF5A35')" class="p-0" text variant="link" @click="editarNovedad(novedad)" title="Editar novedad">
                  <b-icon  variant="warning" icon="pencil" ></b-icon>                  
                </b-btn>
                <b-btn size="sm" v-if="docente && permiso('LB3F483G')" class="mx-1 p-0" text variant="link" @click="eliminarNovedad(novedad)" title="Eliminar novedad">
                  <b-icon  variant="danger" icon="x-circle" ></b-icon>
                </b-btn>
              </b-td>
            </b-tr>
          </b-tbody>
          <b-tbody v-else>
              <tr>
                <td colspan="4" class="text-center">
                  No se encontaron resultados
                </td>
              </tr>

          </b-tbody>
        </b-table-simple>

      </div>
      <hr>
    </div>
    <b-modal @ok="procesarCrear"  @cancel="reiniciarCandidato" v-model="creando"  id="modalCrearNovedad"
    :ok-disabled="!puedeProcesarCrear"  title="Nueva Novedad">

      <div class="mb-2">
        <h5 class="">Fecha:</h5>
        <b-form-input v-model="candidato.fecha" :min="minDate" type="date" @blur="validarFecha"></b-form-input>

        <!--date-picker :not-before="fechaActual" :min="minDate" class="date-picker" v-model="candidato.fecha" lang="es" type="date" 
      :time-picker-options="timePickerOptions" :clearable="true"></date-picker-->
      </div>

      <div class="mb-2" v-if="candidato.fecha">
        <h5 class="">Hora:</h5>
        <b-form-select v-model="candidato.horas" :options="posiblesHoras" multiple :select-size="10" @change="seleccionarHoras"></b-form-select>
      </div>

      <div class="mb-2" v-if="clases && clases.length">
        <h5 class="">Clases:</h5>
        <b-button v-for="(item,index) in clases" :key="index" pill variant="light" size="sm">
          {{item.hora}} <b-badge pill variant="danger">{{item.agendamientos.length}}</b-badge>
        </b-button>

      </div>

      <div class="mb-2" v-if="candidato.fecha && candidato.horas">
        <h5 class="my-1">Motivo:</h5>

        <b-form-select  class="mb-1" v-model="motivoSeleccionado" :options="posiblesMotivos"></b-form-select>
        <div >
          <b-form-textarea
            id="textarea"
           
            v-model="candidato.motivo"
            placeholder="Escriba el motivo de la novedad."
            rows="3"
            max-rows="6"
          ></b-form-textarea>
          <pre class="d-block text-right">{{ candidato.motivo.length }}/{{ motivoMin }}</pre>
        </div>
      </div>

    </b-modal>
    
    <b-modal @ok="procesarEditar"  @cancel="reiniciarCandidato" v-model="editando"  id="modalEditarNovedad"
    :ok-disabled="!puedeProcesarEditar"  title="Editar Novedad">

      <div class="mb-2" v-if="novedadActual">
        <h5 class="">Fecha:</h5>
        {{novedadActual.fecha? novedadActual.fecha : ""}}
      </div>

      <div class="mb-2" v-if="novedadActual">
        <h5 class="">Hora:</h5>
        {{ novedadActual.hora ? novedadActual.hora : '' }}
      </div>

      <div class="mb-2" v-if="clases && clases.length">
        <h5 class="">Clases:</h5>
        <b-button v-for="(item,index) in clases" :key="index" pill variant="light" size="sm">
          {{item.hora}} <b-badge pill variant="danger">{{item.agendamientos.length}}</b-badge>
        </b-button>

      </div>

      <div class="mb-2" v-if="novedadActual && novedadActual.fecha && novedadActual.hora">
        <h5 class="my-1">Motivo:</h5>

        <b-form-select  class="mb-1" v-model="novedadActual.motivo_id" :options="posiblesMotivos"></b-form-select>
        <div >
          <b-form-textarea
            id="textarea"
            v-model="novedadActual.motivo"
            placeholder="Escriba el motivo de la novedad."
            rows="3"
            max-rows="6"
          ></b-form-textarea>
          <pre v-if="novedadActual.motivo" class="d-block text-right">{{ novedadActual.motivo.length }}/{{ motivoMin }}</pre>
        </div>
      </div>

    </b-modal>

    <b-modal @ok="procesarEliminar" @cancel="motivoEliminar=''" v-model="eliminando"  id="modalDesasignar"
    :ok-disabled="motivoEliminar.length<motivosMinEliminar"  title="Motivo">
      <div class="mb-2">
        <b-form-textarea
          id="textarea"
          v-model="motivoEliminar"
          placeholder="Cuéntanos, por qué es necesario eliminar la novedad?"
          rows="3"
          max-rows="6"
        ></b-form-textarea>
        <pre class="d-block text-right">{{ motivoEliminar.length }}/{{ motivosMinEliminar }}</pre>
      </div>
    </b-modal>

    <div v-if="procesando">
      <BlockUI message="procesando..."></BlockUI>
    </div>
  </div>
</template>

<script>
  import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
  import Vue from 'vue';
  import DatePicker from 'vue2-datepicker'
  import utils from '@/modules/utils';

  export default {
    name: 'DocenteNovedades',
    components: {
      DatePicker
    },
    data () {
      const minDate = utils.getHoy()
      return {
        minDate:minDate,
        clases:[],
        timePickerOptions:{
          monthBeforeYear: false
        },
        docente_id: null,
        novedades:[],
        creando: false,
        editando:false,
        procesando: false,
        motivoMin: 30,
        motivosMinEliminar:5,
        motivoSeleccionado: null,
        motivoEliminar:'',
        novedadActual:null,
        eliminando:false,
        candidato : {
          docente_id:null,
          fecha:null,
          horas:[],
          motivo:''
        }
      }
    },
    mounted () {
     this.docente_id = this.$route.params.id;
     if(!this.detalle[this.docente_id]){
        this.actualizarDocente()
      }
      if(this.novedades.length == 0 ){
        this.actualizar()
      }
    },
    
    methods:{
      ...mapActions({
        fetchDetalle: 'docentes/fetchDetalle',
        editar: 'docentes/editar',
        setWarning: 'setWarning',
        setDisponibilidad: 'docentes/setDisponibilidad',
        setCursosPermitidos: 'docentes/setCursosPermitidos',
        setTiposPermitidos: 'docentes/setTiposPermitidos',
        setSalonPreterminado: 'docentes/setSalonPreterminado',
        fetchClases: 'docentes/fetchClases',
        fetchLista: 'docentes/fetchLista',
        deleteNovedad: 'docentes/deleteNovedad'
      }),
      ...mapMutations({
        
      }),
      procesarCancelar(){
        this.fetchDetalle(this.docente_id).then(()=>{
          this.$router.push('/docente/detalle/'+this.docente_id)
        })
      },
      procesarCrear(){
        this.procesando = true
        this.candidato.docente_id = this.docente_id
        if(this.motivoSeleccionado==null){
          console.log('Debe seleccionarse un motivo')
          return
        }
        //if(this.motivoSeleccionado!=10){
          let motivo = this.posiblesMotivos.find(element=>{
            return element.value == this.motivoSeleccionado
          })
          this.candidato.motivo = motivo.text+' / '+this.candidato.motivo
        //}

          Vue.http.post('novedad_docente/crear',this.candidato).then()
          .catch(error=>{
            this.setWarning(error.data)
            console.log(error)
          }).finally(()=>{
            this.procesando = false
            this.actualizar()
            this.reiniciarCandidato()
          })
          
      },

      procesarEditar(){
        this.procesando = true
        //if(this.motivoSeleccionado!=10){
          let motivo = this.posiblesMotivos.find(element=>{
            return element.value == this.novedadActual.motivo_id
          })
          this.novedadActual.motivo = motivo.text+' / '+this.novedadActual.motivo
        //}

          Vue.http.post('novedad_docente/editar',this.novedadActual).then()
          .catch(error=>{
            this.setWarning(error.data)
            console.log(error)
          }).finally(()=>{
            this.procesando = false
            this.actualizar()
            this.reiniciarCandidato()
          })
          
      },
      actualizarDocente(){
        this.fetchDetalle(this.docente_id)
      },
      actualizar(){
        this.procesando = true
        Vue.http.post('novedad_docente/ver',{docente_id:this.docente_id}).then(
          response =>{
            this.novedades = response.data
          }
        )
        .catch(error=>{
          console.log(error)
        }).finally(()=>{
          this.procesando = false
        })

      },
      reiniciarCandidato(){
        this.candidato = {
          docente_id:this.docente_id,
          fecha:null,
          horas:[],
          motivo:''
        }
        this.motivoSeleccionado = null
      },
      eliminarNovedad(novedad) {
        this.novedadActual=novedad;
        this.motivoEliminar='';
        this.eliminando=true;
      },
      editarNovedad(novedad){
        this.novedadActual=novedad;
        this.editando = true;
        let texto = this.novedadActual.observaciones.split('/') 
        
        let motivo = this.posiblesMotivos.find(element=>{
          return element.text == texto[0].trim()
        })
        
        this.novedadActual.motivo_actual = texto[0].trim();
        this.novedadActual.motivo_id = motivo ? motivo.value : null;
        this.novedadActual.motivo = texto[1].trim();

        Vue.set(this.novedadActual, 'id', this.novedadActual.id)
        Vue.set(this.novedadActual, 'hora', this.novedadActual.hora)
        Vue.set(this.novedadActual, 'fecha', this.novedadActual.fecha)
        Vue.set(this.novedadActual, 'motivo_actual', this.novedadActual.motivo_actual)
        Vue.set(this.novedadActual, 'motivo_id', this.novedadActual.motivo_id)
        Vue.set(this.novedadActual, 'motivo', this.novedadActual.motivo)
      },
      procesarEliminar() {
        this.procesando = true;
        let payload = {
          novedad_id:this.novedadActual.id,
          motivo:this.motivoEliminar
        }
        this.deleteNovedad(payload).then((result) => {
            console.log(result);
            this.actualizar();
        }).catch(error=>{
          console.log(error)
        }).finally(()=>{
          this.procesando = false
        });
      },
      seleccionarHoras() {
        this.candidato.docente_id = this.docente_id
        this.fetchClases(this.candidato).then((result) => {
          this.clases = result;
        })
      },
      validarFecha() {
        if (this.candidato.fecha < this.minDate) {
          this.candidato.fecha = null;
        }
      }
    },
    computed:{
      ...mapState({
        detalle: state => state.docentes.detalle, 
        warning: state => state.warning,
        disponibilidad_general: state => state.asw.disponibilidad_general,
      }),
      ...mapGetters({
        permiso: 'auth/permiso', 
      }),
      docente(){
        return this.detalle[this.docente_id]
      },
      puedeProcesarCrear(){
        if(this.candidato && this.candidato.fecha && this.candidato.horas.length>0 
          && this.motivoSeleccionado && 
          //(this.motivoSeleccionado!=10 || this.candidato.motivo.length >= this.motivoMin)
          this.candidato.motivo.length >= this.motivoMin
          ){
          return true
        }
        return false
      },
      puedeProcesarEditar(){
        if(this.novedadActual && this.novedadActual.fecha && this.novedadActual.hora  
          && this.novedadActual.motivo_id && 
          this.novedadActual.motivo.length >= this.motivoMin
          ){
          return true
        }
        return false
      },
      nombreCompleto(){
        let texto = this.docente.primer_nombre
        texto += this.docente.segundo_nombre?(' '+this.docente.segundo_nombre):''
        texto += this.docente.primer_apellido?(' '+this.docente.primer_apellido):''
        texto += this.docente.segundo_apellido?(' '+this.docente.segundo_apellido):''
        return texto
      },
      posiblesHoras(){
        if(this.candidato.fecha){
          let fecha = new Date(this.candidato.fecha+" 00:00:00")
          let dia = fecha.getDay()

          if([1,2,3,4,5,6].includes(dia)){
            let diaObj = this.disponibilidad_general.dias[dia]
            return diaObj.horas.map(element=>{
              return element.hora
            })
          }
        }

        return []
      },

      posiblesMotivos(){
        let lista = [
          {value:1,text:'LR- Licencia Remunerada'},
          {value:2,text:'LNR- Licencia No Remunerada'},
          {value:3,text:'INCAP- Incapacidad'},
          {value:4,text:'RTDO- Llegada tarde'},
          {value:5,text:'VCS- Vacaciones'},
          {value:6,text:'INAS- Inasistencia'},
          {value:10,text:'Otro'},
        ]
        return lista

      },
      fechaActual(){
        let fecha = utils.getManana()
        return utils.getManana()
      },

      
    }
    
  }
</script>

<style scope>

  .perfil_wrapper .container{
      background-color: #fff;
      padding: 15px;
  }
</style>